import { useRef, useEffect } from 'react';
import { useZusModalStore } from '@/helpers/modal.js';
import ModalWrapper from '@/helpers/modals/skin4.js';

function VoiceflowChatContent() {
  const chatContainerRef = useRef();
  const { setModal1 } = useZusModalStore.getState();

  useEffect(() => {
    // Vérifier si l'URL contient le paramètre pour ouvrir le chat
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('openChat') === 'true') {
      const content = (
        <ModalWrapper onClose={() => setModal1(null)} delay={50}>
          <VoiceflowChatContent />
        </ModalWrapper>
      );
      setModal1(content);
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.onload = function () {
      window.voiceflow.chat.load({
        verify: { projectID: '680a5e35a47ce6d1340015f7' },
        url: 'https://general-runtime.voiceflow.com',
        versionID: 'production',
        voice: {
          url: 'https://runtime-api.voiceflow.com',
        },
        render: {
          mode: 'embedded',
          target: chatContainerRef.current,
        },
      });
    };
    script.src = 'https://cdn.voiceflow.com/widget-next/bundle.mjs';
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [setModal1]);

  return (
    <div className="flex items-center justify-center w-screen h-screen overflow-hidden">
      <div className="rounded-2xl overflow-hidden h-[65vh] w-[400px] ">
        <div className="block w-full h-full" ref={chatContainerRef} />
      </div>
    </div>
  );
}

export const openVoiceflowChat = () => {
  const { setModal1 } = useZusModalStore.getState();
  const content = (
    <ModalWrapper onClose={() => setModal1(null)} delay={50}>
      <VoiceflowChatContent />
    </ModalWrapper>
  );
  setModal1(content);
};

// Composant pour l'ouverture automatique basée sur l'URL
export function VoiceflowChatAutoOpen() {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('openChat') === 'true') {
      openVoiceflowChat();
    }
  }, []);

  return null;
}

export default VoiceflowChatContent;
